module.exports = __webpack_public_path__ + "static/media/diamonds-queen.c5c44b54.png";